export default "__VITE_ASSET__BB4$k3eJ__"